import {useContext} from "react";

import {MobileIconMenuAPIContext} from "./mobile-icon-menu-context.ts";

/**
 * Hook providing an API for updating the state of the mobile icon menu.
 */
export const useMobileIconMenuAPI = (): ((isOpen: boolean) => void) =>
    useContext(MobileIconMenuAPIContext);
